import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function MediaKit() {
  const [open, setOpen] = useState(false);
  const [form, setForm] = useState({ name: "", email: "", organization: "" });
  const [loading, setLoading] = useState(false);

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.email) return toast.error("Name and email required.");
    setLoading(true);
    try {
      await axios.post(`${API}/media-kit/request`, form);
      toast.success("Media kit emailed. Download starting…");
      // also trigger direct download
      const a = document.createElement("a");
      a.href = `${API}/media-kit.pdf`;
      a.download = "Dr_Cj_Avory_Media_Kit.pdf";
      document.body.appendChild(a);
      a.click();
      a.remove();
      setOpen(false);
      setForm({ name: "", email: "", organization: "" });
    } catch (err) {
      toast.error("Could not send. Try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      id="media-kit"
      data-testid="media-kit-section"
      className="mt-16 border border-[#262626] bg-[#0e0e0e] grid lg:grid-cols-12"
    >
      <div className="lg:col-span-5 p-8 lg:p-10 border-b lg:border-b-0 lg:border-r border-[#262626]">
        <div className="overline overline-red mb-4">Press · Conference Organizers</div>
        <h3 className="font-display font-extrabold text-3xl sm:text-4xl tracking-[-0.025em] leading-[0.95]">
          Media Kit
          <br />
          <span className="text-[#d92d20]">one-pager.</span>
        </h3>
        <p className="mt-5 text-white/65 text-sm leading-relaxed max-w-sm">
          Bio, signature topics, engagement formats, booking contact — formatted
          for press, panels, and conference programs.
        </p>
      </div>

      <div className="lg:col-span-7 p-8 lg:p-10 flex flex-col">
        <div className="grid grid-cols-3 gap-px bg-[#262626] border border-[#262626] mb-8">
          <Stat k="Format" v="PDF · 1pg" />
          <Stat k="Topics" v="5 keynote" />
          <Stat k="Contact" v="Direct booking" />
        </div>

        {!open ? (
          <div className="flex flex-col sm:flex-row gap-3 mt-auto">
            <button
              data-testid="media-kit-open"
              onClick={() => setOpen(true)}
              className="inline-flex items-center justify-center gap-3 bg-[#d92d20] hover:bg-[#b91d13] text-white px-7 py-4 text-[12px] font-semibold tracking-[0.18em] uppercase transition-colors flex-1"
            >
              Download Media Kit →
            </button>
            <a
              href={`${API}/media-kit.pdf`}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="media-kit-preview"
              className="inline-flex items-center justify-center gap-3 border border-[#404040] hover:border-white text-white px-7 py-4 text-[12px] font-semibold tracking-[0.18em] uppercase transition-colors"
            >
              Preview
            </a>
          </div>
        ) : (
          <form onSubmit={submit} data-testid="media-kit-form" className="space-y-5 mt-auto">
            <div className="grid sm:grid-cols-2 gap-5">
              <label>
                <span className="overline block mb-2">Name <span className="text-[#d92d20]">*</span></span>
                <input
                  data-testid="media-kit-name"
                  required
                  className="brut-input"
                  value={form.name}
                  onChange={set("name")}
                />
              </label>
              <label>
                <span className="overline block mb-2">Email <span className="text-[#d92d20]">*</span></span>
                <input
                  data-testid="media-kit-email"
                  type="email"
                  required
                  className="brut-input"
                  value={form.email}
                  onChange={set("email")}
                />
              </label>
            </div>
            <label className="block">
              <span className="overline block mb-2">Organization / Outlet</span>
              <input
                data-testid="media-kit-org"
                className="brut-input"
                value={form.organization}
                onChange={set("organization")}
              />
            </label>
            <div className="flex items-center gap-3 pt-2">
              <button
                type="submit"
                disabled={loading}
                data-testid="media-kit-submit"
                className="inline-flex items-center justify-center gap-3 bg-[#d92d20] hover:bg-[#b91d13] disabled:opacity-60 text-white px-7 py-4 text-[12px] font-semibold tracking-[0.18em] uppercase transition-colors"
              >
                {loading ? "Preparing…" : "Email & Download →"}
              </button>
              <button
                type="button"
                onClick={() => setOpen(false)}
                data-testid="media-kit-cancel"
                className="text-white/55 hover:text-white text-xs uppercase tracking-[0.18em]"
              >
                Cancel
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}

function Stat({ k, v }) {
  return (
    <div className="bg-[#0a0a0a] p-4">
      <div className="overline mb-1">{k}</div>
      <div className="text-white text-sm font-medium">{v}</div>
    </div>
  );
}
